import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedReceiptDateRange: [],
  allCurrencies: [],
  allCompanies: [],
  pairingRate: [],
  receiptData: null,
  isReceiptLoading: false,
  page: 0,
  rowsPerPage: 10,
  sort: {
    keytoSort: "",
    direction: "desc",
  },
  selectedReceiptNumber: [],
  selectedCompany: [],
  selectedFME: [],
  selectedDate: null,
  selectedStatus: [],
  selectedAccount: [],
  selectedPercentCovered: [],
  selectedRow: [],
  selectedReceipt: [],
  manualReceiptsPayload: [],
  uploadReceiptsPayload: [],
  receipts: [
    {
      id: 1,
      receiptNumber: "",
      receiptAmount: "",
      company: null,
      currency: null,
      date: null,
      fmeRecords: [],
    },
  ],
  editReceipts: [
    {
      id: 1,
      receiptNumber: "",
      receiptAmount: "",
      company: null,
      currency: null,
      status: { label: "Not Final" },
      date: null,
    },
  ],
  loadingModal: false,
  manualEditReceiptsPayload: [],
  linkedFmes: [],
  editReceiptsInitialized: false,
  financialMonthlyEarningsData: [],
  normalizedFinancialMonthlyEarningsData: [],
  FMERecordsLoading: false,
  selectedCompanyToBrowseFME: null,
  selectedDateFilterPair: null,
  selectedStatusFilterPair: null,
  selectedLinkedFilterPair: null,
  selectedFinanceCompanyFilter: null,
  FMEIdPair: null,
  linkedFmesByReceipt: {},
  activeReceiptSharedUid: null,
  unpairPreviewReceipt: null,
  unpairPayload: null,
  editUnpairPayload: null,
  editUnpairSelectedFmeId: null,
  failedReceiptStatus: null,
  failedReceipts: [],
  failedReceiptsPayload: [],
  financeCompanyLoadingTable: false,
};

const financeReceiptSlice = createSlice({
  name: "receipts",
  initialState,
  reducers: {
    setSelectedReceiptDateRange: (state, action) => {
      state.selectedReceiptDateRange = action.payload;
    },
    setAllCurrencies: (state, action) => {
      state.allCurrencies = action.payload;
    },
    setAllCompanies: (state, action) => {
      state.allCompanies = action.payload;
    },
    setPairingRate: (state, action) => {
      state.pairingRate = action.payload;
    },
    setReceiptData: (state, action) => {
      state.receiptData = action.payload;
    },
    setIsReceiptLoading: (state, action) => {
      state.isReceiptLoading = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setSelectedReceiptNumber: (state, action) => {
      state.selectedReceiptNumber = action.payload;
    },
    setSelectedCompany: (state, action) => {
      state.selectedCompany = action.payload;
    },
    setSelectedFME: (state, action) => {
      state.selectedFME = action.payload;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload;
    },
    setSelectedAccount: (state, action) => {
      state.selectedAccount = action.payload;
    },
    setSelectedPercentCovered: (state, action) => {
      state.selectedPercentCovered = action.payload;
    },
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    setSelectedReceipt: (state, action) => {
      state.selectedReceipt = action.payload;
    },
    setManualReceiptsPayload: (state, action) => {
      state.manualReceiptsPayload = action.payload;
    },
    setUploadReceiptsPayload: (state, action) => {
      state.uploadReceiptsPayload = action.payload;
    },
    setReceipts: (state, action) => {
      state.receipts = action.payload;
    },
    resetReceiptsForm: (state) => {
      state.receipts = initialState.receipts;
    },
    setLoadingModal: (state, action) => {
      state.loadingModal = action.payload;
    },
    setEditReceipts: (state, action) => {
      state.editReceipts = action.payload;
    },
    setManualEditReceiptsPayload: (state, action) => {
      state.manualEditReceiptsPayload = action.payload;
    },
    setLinkedFmes: (state, action) => {
      state.linkedFmes = action.payload;
    },
    removeLinkedFme: (state, action) => {
      state.linkedFmes = state.linkedFmes.filter(
        (fme: any) => fme.fme_id !== action.payload,
      );
    },
    setEditedReceiptsInitialized: (state, action) => {
      state.editReceiptsInitialized = action.payload;
    },
    setFinancialMonthlyEarningsData: (state, action) => {
      state.financialMonthlyEarningsData = action.payload;
    },
    setFMERecordsLoading: (state, action) => {
      state.FMERecordsLoading = action.payload;
    },
    setSelectedCompanyToBrowseFME: (state, action) => {
      state.selectedCompanyToBrowseFME = action.payload;
    },
    setSelectedDateFilterPair: (state, action) => {
      state.selectedDateFilterPair = action.payload;
    },
    setSelectedStatusFilterPair: (state, action) => {
      state.selectedStatusFilterPair = action.payload;
    },
    setSelectedLinkedFilterPair: (state, action) => {
      state.selectedLinkedFilterPair = action.payload;
    },
    setFMEIdPair: (state, action) => {
      state.FMEIdPair = action.payload;
    },
    setNormalizedFinancialMonthlyEarningsData: (state, action) => {
      state.normalizedFinancialMonthlyEarningsData = action.payload;
    },
    setActiveReceiptSharedUid: (state, action) => {
      state.activeReceiptSharedUid = action.payload;
    },

    addFmeToReceipt: (state: any, action) => {
      const { receiptSharedUid, fme } = action.payload;

      if (!state.linkedFmesByReceipt[receiptSharedUid]) {
        state.linkedFmesByReceipt[receiptSharedUid] = [];
      }

      const exists = state.linkedFmesByReceipt[receiptSharedUid].some(
        (x: any) => x.shared_uid === fme.shared_uid,
      );

      if (!exists) {
        state.linkedFmesByReceipt[receiptSharedUid].unshift(fme);
      }
    },
    removeFmeFromReceipt: (state: any, action) => {
      const { receiptSharedUid, fmeSharedUid } = action.payload;

      if (!state.linkedFmesByReceipt[receiptSharedUid]) return;

      state.linkedFmesByReceipt[receiptSharedUid] = state.linkedFmesByReceipt[
        receiptSharedUid
      ].filter((fme: any) => fme.shared_uid !== fmeSharedUid);

      // Optional cleanup: remove empty array
      if (state.linkedFmesByReceipt[receiptSharedUid].length === 0) {
        state.linkedFmesByReceipt[receiptSharedUid] = [];
      }
    },
    removeAllFmesForReceipt: (state: any, action) => {
      const receiptSharedUid = action.payload;

      if (state.linkedFmesByReceipt[receiptSharedUid]) {
        delete state.linkedFmesByReceipt[receiptSharedUid];
      }

      // Optional safety: reset active receipt if it was this one
      if (state.activeReceiptSharedUid === receiptSharedUid) {
        state.activeReceiptSharedUid = null;
      }
    },
    clearAllLinkedFmes: (state) => {
      state.linkedFmesByReceipt = {};
      state.activeReceiptSharedUid = null;
    },
    setUnpairPreviewReceipt(state, action) {
      state.unpairPreviewReceipt = action.payload;
    },
    setUnpairPayload(state, action) {
      state.unpairPayload = action.payload;
    },
    setEditUnpair: (state, action) => {
      state.editUnpairPayload = action.payload.payload;
      state.editUnpairSelectedFmeId = action.payload.fme_id;
    },

    clearEditUnpair: (state) => {
      state.editUnpairPayload = null;
      state.editUnpairSelectedFmeId = null;
    },
    setFailedReceiptStatus: (state, action) => {
      state.failedReceiptStatus = action.payload;
    },
    setFailedReceipts: (state, action) => {
      state.failedReceipts = action.payload;
    },
    setFailedReceiptsPayload: (state, action) => {
      state.failedReceiptsPayload = action.payload;
    },
    setSelectedFinanceCompanyFilter: (state, action) => {
      state.selectedFinanceCompanyFilter = action.payload;
    },
    setFinanceCompanyLoadingTable: (state, action) => {
      state.financeCompanyLoadingTable = action.payload;
    },
  },
});

export const {
  setSelectedReceiptDateRange,
  setAllCurrencies,
  setAllCompanies,
  setPairingRate,
  setReceiptData,
  setIsReceiptLoading,
  setPage,
  setRowsPerPage,
  setSort,
  setSelectedReceiptNumber,
  setSelectedCompany,
  setSelectedFME,
  setSelectedDate,
  setSelectedStatus,
  setSelectedAccount,
  setSelectedPercentCovered,
  setSelectedRow,
  setSelectedReceipt,
  setManualReceiptsPayload,
  setUploadReceiptsPayload,
  setReceipts,
  resetReceiptsForm,
  setLoadingModal,
  setEditReceipts,
  setManualEditReceiptsPayload,
  setLinkedFmes,
  removeLinkedFme,
  setEditedReceiptsInitialized,
  setFinancialMonthlyEarningsData,
  setFMERecordsLoading,
  setSelectedCompanyToBrowseFME,
  setSelectedDateFilterPair,
  setSelectedStatusFilterPair,
  setSelectedLinkedFilterPair,
  setNormalizedFinancialMonthlyEarningsData,
  setFMEIdPair,
  setActiveReceiptSharedUid,
  addFmeToReceipt,
  removeFmeFromReceipt,
  removeAllFmesForReceipt,
  clearAllLinkedFmes,
  setUnpairPreviewReceipt,
  setUnpairPayload,
  setEditUnpair,
  clearEditUnpair,
  setFailedReceiptStatus,
  setFailedReceipts,
  setFailedReceiptsPayload,
  setSelectedFinanceCompanyFilter,
  setFinanceCompanyLoadingTable,
} = financeReceiptSlice.actions;

export default financeReceiptSlice.reducer;
